import { motion } from 'framer-motion';
import { Button, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <Box sx={{
      height: '90vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/hero-bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'white',
      padding: '0 20px'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Investing in the Architects of Private Markets
        </Typography>
        <Typography variant="h5" component="p" sx={{ mb: 4 }}>
          Aquamire acquires minority stakes in top-tier private market asset managers, capturing the full spectrum of their economics.
        </Typography>
        <Button 
          variant="contained" 
          size="large" 
          color="primary"
          sx={{ 
            padding: '12px 30px',
            fontSize: '1.1rem',
            fontWeight: 'bold'
          }}
          component={Link} 
          to="/strategy"
        >
          Explore Our Strategy
        </Button>
      </motion.div>
    </Box>
  );
};

export default Hero;
